import { getSessionDataConfig } from '../config';

// Module-scope and referentially stable so an absent → present wiring cannot
// change the hook count (see `SessionDataConfig` for the same hazard on
// `useAuthToken`).
const NO_SUBSCRIPTION = () => {};

/**
 * The live-transcript query is the app's capture boundary, so the
 * subscription crosses the config seam rather than living in each reader.
 */
export const useLiveTranscriptSubscription = (sessionId: string): void => {
  const useSubscription =
    getSessionDataConfig().useLiveTranscriptSubscription ?? NO_SUBSCRIPTION;
  useSubscription(sessionId);
};
